import landingAnchors from "consts/landingAnchors";
import {landingContentTabs} from "consts/landingContentTabs";

export default [
    {label: "landing.header.tabs.courses", anchor: landingAnchors.courses},
    {label: "landing.header.tabs.games", anchor: landingAnchors.content, newContentTab: landingContentTabs.games},
    {label: "landing.header.tabs.books", anchor: landingAnchors.content, newContentTab: landingContentTabs.books}
    // {label: "landing.header.tabs.tutors", anchor: landingAnchors.tutors}
];
